<template>
  <div id="welcome-status">
    <h1>Eternal Monitoring</h1>
    <div class="test-container">
      <echo-test endpoint="https://api.werksoft.net/eternal/dev/echo/" />
      <mock-ephemeral-tests />
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  export default {
    computed: mapGetters(['amazonAuthenticated']),
    mounted: function () {
      if (!this.amazonAuthenticated) {
        this.$router.push('/unlock-secret')
      }
    }
  }
</script>
<style lang="less">
  .test-container {
    display: flex;
    flex-wrap: initial;

    .test {
      width: 300px;
      height: 150px;
      border: 1px solid #666;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/WelcomeStatus.vue